export default __webpack_public_path__ + "static/media/withdrawal-rosn.cd5891f7.svg";